import { TopbarController } from "./topbar.controller";

angular
    .module("thor.shared.topbar.component", [])
    .component("thorTopbar", {
        controller: TopbarController,
        template: require("../../shared/topbar/topbar.html")
    });
